import ExpandableCardBody from 'ui/components/BaseExpandableCard/components/ExpandableCardBody'
import Button from 'ui/components/buttons/Button/'
import Checklist from 'ui/components/checklist/Checklist'
import TemplateCard from 'ui/modules/Templates/components/TemplateCard'

const TemplatesSelectItem = ({
  id,
  name,
  taskType,
  content,
  checklists,
  expanded,
  onToggle,
  onApply,
}) => {
  return (
    <TemplateCard
      id={id}
      name={name}
      taskType={taskType}
      expanded={expanded}
      onToggle={onToggle}
      iconPosition="left"
      iconGap={8}
      scrollable
      actions={
        <Button
          title="Применить"
          type="button"
          theme="borderBlue"
          onClick={(e) => {
            e.stopPropagation()
            onApply()
          }}
        />
      }
    >
      <>
        <ExpandableCardBody template={content} />

        {checklists?.map((checklist) => (
          <Checklist
            key={checklist.id}
            checklist={checklist}
            variant="template"
          />
        ))}
      </>
    </TemplateCard>
  )
}

export default TemplatesSelectItem
